import * as Sentry from "@sentry/vue";
import axios from "axios";
import { appInDevMode, getAppEnvFromHost } from "../utils/helpers";

export const initSentry = (app) => {
    Sentry.init({
        app,
        dsn: process.env.MIX_SENTRY_VUE_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration(),
        ],
        environment: getAppEnvFromHost(),
        release: process.env.MIX_APP_VERSION,
        enabled: !appInDevMode(),
        ignoreErrors: ["Request failed with status code", 'Network Error'],
        beforeSend(err) {
            if(axios.isAxiosError(err)) {
                return null;
            }
            
            return err;
        },
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 0.1,
    });
}

export default Sentry
